import { getCarouselImageSrc, type CarouselImage } from './ImageCarousel';

/** A slide's CSS box — `--carousel-item-width` at a 4 / 3 aspect ratio. */
export const CAROUSEL_SLIDE_WIDTH = 200;
export const CAROUSEL_SLIDE_HEIGHT = 150;

/** What a slide draws: an attachment's slide-sized copy when it has one. */
export const getCarouselSlideSrc = (img: CarouselImage): string =>
  img.type === 'attachment' ? (img.thumb ?? img.src) : getCarouselImageSrc(img);
